import { track } from '@tldraw/tldraw'
import { Button } from 'blaze-ui/Button'
import { Plus } from 'blaze-ui/icons'
import { Color as VisualEditorColor, GradientColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { observer } from 'mobx-react-lite'
import Color from 'colorjs.io'

interface Props {
  selectedColor: GradientColor
  onNewColorChange: (color: VisualEditorColor) => void
}

export const AddGradientStopButton = track(
  observer(({ selectedColor, onNewColorChange }: Props) => {
    const handleAdd = () => {
      const existingStops = selectedColor.stops
      const lastStop = existingStops[existingStops.length - 1]
      const penultimateStop = existingStops[existingStops.length - 2]

      const interpolatedColor = new Color(penultimateStop.color).range(new Color(lastStop.color), { space: 'srgb' })(
        0.5,
      )

      const newStop = {
        position: (lastStop.position + penultimateStop.position) / 2,
        opacity: (lastStop.opacity + penultimateStop.opacity) / 2,
        color: interpolatedColor.toString({ format: 'hex' }),
      }

      const updatedStops = [...existingStops]
      updatedStops.splice(updatedStops.length - 1, 0, newStop)

      const newColor = {
        ...selectedColor,
        stops: updatedStops,
      }

      onNewColorChange(newColor)
    }

    return (
      <Button
        size="xs"
        frontIcon={Plus}
        variant="ghost"
        onPress={handleAdd}
        isDisabled={selectedColor.stops.length >= 6}
      >
        Add
      </Button>
    )
  }),
)
